<template>
  <AppShell :nav-items="navItems" :admin-nav-items="adminNavItems" />
</template>

<script>
import AppShell from "@shared/components/AppShell.vue";
import { claimPendingGuestImages } from "./utils/guestClaims";

export default {
  name: "App",
  components: {
    AppShell
  },
  watch: {
    // The moment the session becomes a real member (registration upgrade or
    // login), adopt any conversions still owned by a landing-page guest so
    // the gallery is complete without visiting each result URL.
    "$store.getters.currentUser": {
      immediate: true,
      handler(user) {
        if (user && !user.is_anonymous) {
          claimPendingGuestImages().catch(function () {});
        }
      }
    }
  },
  computed: {
    // Primary drawer navigation.
    navItems() {
      return [
        { icon: "mdi-auto-fix", title: "Enhance", to: "/" },
        { icon: "mdi-image-multiple-outline", title: "Gallery", to: "/gallery" },
        { icon: "mdi-currency-usd", title: "Pricing", to: "/pricing" },
        { icon: "mdi-help-circle-outline", title: "FAQ", to: "/faq" }
      ];
    },
    // Admin-only drawer navigation - same generic admin screens every app
    // gets via createBaseRoutes (frontend-shared/src/router/createBaseRoutes.js).
    adminNavItems() {
      return [
        { icon: "mdi-shield-account-outline", title: "Admin", to: "/admin" },
        {
          icon: "mdi-email-fast-outline",
          title: "Send Email",
          to: "/admin/email"
        },
        { icon: "mdi-bug-outline", title: "Issues", to: "/admin/issues" },
        { icon: "mdi-server-outline", title: "Ops", to: "/admin/ops" }
      ];
    }
  }
};
</script>
